import { useState } from "react";
import { toast } from "../lib/toast";

type UseCopyReturn = [boolean, (url: string) => Promise<void>];

export default function useCopy(): UseCopyReturn {
  const [loading, setLoading] = useState(false);

  const handleCopy = async (url: string) => {
    setLoading(true);
    try {
      await navigator.clipboard.writeText(url);
      toast("success", "Copied to clipboard!", "s");
    } catch (error) {
      toast("error", "Failed to copy!", "s");
    }
    setLoading(false);
  };

  return [loading, handleCopy];
}
